import { IconButton } from '@chakra-ui/react'
import { useColorMode } from '@components/ui/color-mode'
import { LuSun, LuMoon } from 'react-icons/lu'

const ToggleColorMode = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  
  return (
    <IconButton onClick={toggleColorMode} variant="outline" size="sm">
      {colorMode === "light" ? <LuSun /> : <LuMoon />}
    </IconButton>
  );
};

export default ToggleColorMode;
